
import type { BaseErrorResponse, GetDataExportRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useDataExport() {
  class DataExport<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Data export
     * @name DataExportControllerGetDeliveries
     * @summary Returns data exports
     * @request GET:/api3/data-export
     * @secure
     * @response `200` `GetDataExportRes`
     * @response `400` `BaseErrorResponse`
     */
    dataExportControllerGetDeliveries = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDataExportRes, BaseErrorResponse>({
        path: '/api3/data-export',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new DataExport();
}
